import { Dispatch, SetStateAction } from "react";
import { User } from "../UserManagement";

export enum FormAccess {
  VIEW = "View",
  EDIT = "Edit",
  CREATE = "Create",
  DELETE = "Delete",
}

export enum ServiceStatus {
  NEW = "Pending",
  SENT = "Pending Payment",
  DENIED = "Denied",
  ACCEPT = "Accept Payment",
  PAYMENT_DENIED = "Deny Payment",
  COMPLETED = "Service Completed",
  CANCELLED = "Service Cancelled",
}

export type Service = {
  id: string;
  service: string;
  price: string;
  serviceDate: string;
  createdAt: string;
  serviceTime: string;
  userId: string;
  user: User;
  message: string;
  registeredUser: boolean;
  status: ServiceStatus;
  serviceType: ServiceType;
  //user data
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  unitNumber: string;
  streetNumber: string;
  streetName: string;
  suburb: string;
  vicPostalCode: string;
  state: string;
};

export type ServiceType = {
  name: string;
  id: string;
  price: string;
};

export type ServiceModalDetailsType = {
  id: string | undefined;
  type: FormAccess;
};

export type ServiceRowType = Service & {
  setCentered?: Dispatch<SetStateAction<boolean>>;
  modalDetails?: Dispatch<SetStateAction<ServiceModalDetailsType | undefined>>;
};

export type GetRequestsRenseponse = {
  data: {
    serviceRequests: Service[];
  };
  error: string;
};
